import { BaseRule } from '../rule-base';
import { AdjustedLine, ModifierContext } from '../modifier-models';

export class Rule0004 extends BaseRule {
    name = '0004 own rooms (fee ×2)';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        // only on real standalone modifier 0004 lines
        if (!line.isModifier || !(line.code === '0004')) return;

        // ——— derive the current “base” fee from the pristine value
        const baseRand = ctx.totalPrice || 0;
        const newRand = +(baseRand).toFixed(2);

        if (autoApply) {
            line.adjustedRand = newRand;
            line.trace.push(`0004: own rooms fee x2 → +R${newRand}`);
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0004',
                message: 'Procedure in own rooms: fee x2',
                kind: 'overwrite',
                randDelta: newRand
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        return lines.map(l => {
            if (!l.isModifier || !(l.code === '0004')) return l;

            const baseRand = ctx.totalPrice || 0;
            const newRand = +(baseRand).toFixed(2);

            l.adjustedRand = newRand;
            l.trace.push(`0004: own rooms fee x2 → +R${(newRand).toFixed(2)}`);
            return l;
        });
    }
}
